// extracted by mini-css-extract-plugin
module.exports = {"w12axtos":"w12axtos","iyjseu3":"iyjseu3","hb0iifv":"hb0iifv"};